<template>
    <div class="card">
        <div class="card-content">
        <p class="title">{{ SeriesData.row.Series.Title }}({{ SeriesData.row.Series.OriginalTitle }}) ({{SeriesData.row.Series.YearBegin}}-{{SeriesData.row.Series.YearEnd}})</p>
        <p class="subtitle">di {{ SeriesData.created_by}}</p>
        <p class="subtitle">{{SeriesData.genre_string}}, {{SeriesData.tmdb.number_of_episodes}} ep. in {{SeriesData.tmdb.number_of_seasons}} stagioni</p>
        <div class="media">
            <div class="media-left">
            <figure class="image" width="50%">
                <img
                :src="
                    'http://image.tmdb.org/t/p/w185/' +
                    SeriesData.tmdb.poster_path
                "
                alt="Poster"
                />
            </figure>
            </div>

            <div class="media-content">
            <p v-if="SeriesData.tmdb.tagline" class="subtitle">{{SeriesData.tmdb.tagline}} </p>
            <p>{{SeriesData.tmdb.overview}}</p><br/>
            <p><i>Stato globale di visione: {{SeriesData.row.SeriesStatus}}</i></p> <br/>
            <p>La stagione {{SeriesData.row.Number}} è stata iniziata il {{SeriesData.row.DateBeginDate}} e {{SeriesData.row.DateEndDate?"finita il "+ SeriesData.row.DateEndDate:"non ancora terminata"}}</p>
             <p>{{SeriesData.row.Comment}}                         
             
             <star-rating v-if="SeriesData.row.Dicks"
                    v-model="SeriesData.row.Dicks"
                    :show-rating="false"
                    :read-only="true"
                    :increment="0.5"
                    :star-size="30"
                  /></p>
            </div>
        </div>
        </div>
        <footer class="card-footer">
        <a href="#" @click="doEdit" class="card-footer-item">Edit</a>
        <a href="#" @click="doNewSeason" class="card-footer-item">Nuova stagione</a>
        <a href="#" @click="doDelete" class="card-footer-item">Scancellala!</a>
        <a :href="'https://www.imdb.com/title/'+SeriesData.row.Series.ImdbId" target="_blank" class="card-footer-item">Imdb</a>
        <a href="#" @click= "doClose" class="card-footer-item">Chiudi</a>
        </footer>
    </div>
</template>

<script>
import StarRating from "vue-star-rating";
export default {
  name: 'SeriesDetails',
  components: { StarRating  },
  methods: {
   doEdit() {
      this.$emit("SeriesDetailsEdit"); 
   }  ,
   doDelete() {
      this.$emit("SeriesDetailsDelete"); 
   },
   doNewSeason() {
      this.$emit("SeriesDetailsNewSeason"); 
   },
   doClose() {
      this.$parent.close();
   } 
  },
  props: ['SeriesData'],
  
  data() {
    return {
    };
  },
  mounted() {
    
  }
};
</script>

<style lang="scss">


</style>